<template>
  <div>
    <ul class="list-none divide-y divide-gray-200" v-for="{ value, label, badgeCondition, badgeContent } in options">
      <li :key="value">
        <a
          href="#"
          @click.prevent="select(value)"
          class="w-full py-5 flex justify-between items-center text-black hover:no-underline hover:text-black"
        >
          <div class="flex items-center space-x-3">
            <span class="font-medium text-md">{{ label }}</span>
            <span
              v-if="badgeCondition"
              class="w-[18.5px] h-[18.5px] flex items-center justify-center bg-primary text-white text-xs rounded-full"
            >
              {{ badgeContent }}
            </span>
          </div>
          <FaIcon :icon="['fas', 'chevron-right']" class="h-6 w-6 text-black" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup>
import useCategoriesCount from "@/pages/ListingsPage/filters/mobile/hooks/useCategoriesCount"
import useCommonCount from "@/pages/ListingsPage/filters/mobile/hooks/useCommonCount"
import useDisplayCount from "@/pages/ListingsPage/filters/mobile/hooks/useDisplayCount"
import usePriceCount from "@/pages/ListingsPage/filters/mobile/hooks/usePriceCount"
import useSizeCount from "@/pages/ListingsPage/filters/mobile/hooks/useSizeCount"
import useSortCount from "@/pages/ListingsPage/filters/mobile/hooks/useSortCount"
import { computed } from "vue"

const { showPrizeCategories } = defineProps({
  showPrizeCategories: {
    type: Boolean,
    required: false,
    default: false,
  },
  select: {
    type: Function,
    required: true,
  },
})

const priceCount = usePriceCount()
const sizeCount = useSizeCount()
const sortCount = useSortCount()
const categoriesCount = useCategoriesCount()
const displayCount = useDisplayCount()
const subjectCount = useCommonCount("collections")
const colorsCount = useCommonCount("colors")
const styleCount = useCommonCount("art_styles")
const orientationCount = useCommonCount("orientations")
const mediumCount = useCommonCount("mediums")
const locationCount = useCommonCount("locations")
const prizeCategoriesCount = useCommonCount("competition_category_ids")
const options = computed(() =>
  [
    {
      label: "Sort",
      value: "sort",
      ...sortCount.value,
    },
    {
      label: "Price",
      value: "prices",
      ...priceCount.value,
    },
    {
      label: "Size",
      value: "sizes",
      ...sizeCount.value,
    },
    {
      label: "Medium",
      value: "mediums",
      ...mediumCount.value,
    },
    {
      label: "Categories",
      value: "categories",
      ...categoriesCount.value,
    },
    {
      label: "Prize Category",
      value: "prize_categories",
      hidden: !showPrizeCategories,
      ...prizeCategoriesCount.value,
    },
    {
      label: "Subject",
      value: "collections",
      ...subjectCount.value,
    },
    {
      label: "Style",
      value: "art_styles",
      ...styleCount.value,
    },
    {
      label: "Colour",
      value: "colors",
      ...colorsCount.value,
    },
    {
      label: "Orientation",
      value: "orientations",
      ...orientationCount.value,
    },
    {
      label: "Artist Location",
      value: "locations",
      ...locationCount.value,
    },
    {
      label: "Display",
      value: "displays",
      ...displayCount.value,
    },
  ].filter((option) => !option.hidden),
)
</script>

<script>
export default {
  name: "Refine",
}
</script>
